import Footer from "../Footer";
import NavbarTop from "../NavbarTop";
import MenuInicioRapido from "../MenuInicioRapido";
import React, { useEffect, useState } from "react";
import MenuDataIntelligence from "../MenuDataIntelligence";
import PesquisaArtigo from "../PesquisaArtigo";

export default function ErroEnriquecimento() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollButton && window.pageYOffset > 400) {
        setShowScrollButton(true);
      } else if (showScrollButton && window.pageYOffset <= 400) {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScrollButton]);
  useEffect(() => {
    // Rola a página para o topo sempre que a página é carregada
    window.scrollTo(0, 0);
  }, []); // Executa o efeito apenas uma vez, quando o componente é montado

  return (
    <>
      <section>
        <div>
          <NavbarTop />
        </div>

        <div className="container col-md-11">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>

                  <li className="breadcrumb-item active">
                    <a href="data-intelligence">Data Intelligence</a>
                  </li>

                  <li className="breadcrumb-item active">
                    Solução de problemas - Enriquecimento com erro ou pendências
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuDataIntelligence />
            </div>

            <div className="col-md-6">
              <h1 className="article-heading">
                Solução de problemas - Enriquecimento com erro ou pendências
              </h1>
              <hr />

              <div className="row justify-content-between" id="article-meta">
                <div className="author col-6 pl-5">
                  <span className="author-name">Data Intelligence</span>
                </div>
                <small className="col-6 text-right pr-5">
                  Enriquecimento de Dados
                </small>
              </div>
              <hr />

              <div className="content article-content">
                <br></br>

                <p>
                  Devido a algumas configurações específicas, o arquivo pode não
                  ser enriquecido ou ser enriquecido com pendências. Isso
                  significa que ajustes poderão ser necessários, garantindo
                  maior precisão e completude no enriquecimento.
                </p>

                <p>
                  Neste tópico, apresentamos as possíveis ações a serem tomadas
                  caso o seu arquivo não seja enriquecido ou seja enriquecido
                  com pendências.
                </p>

                <p>
                  <h3>Erros comuns no enriquecimento</h3>
                </p>

                <p>
                  <h5>Arquivo diferente do tipo .xlsx ou .csv</h5>
                </p>

                <p>
                  Caso o arquivo enviado não seja do tipo .xlsx ou .csv, é
                  importante verificar o formato do documento. Para garantir a
                  compatibilidade, siga estas orientações:
                </p>

                <ul>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Verifique o formato atual do arquivo:{" "}
                    </a>
                    Certifique-se de que o arquivo esteja em um formato aceito.
                    Arquivos de outros tipos podem não ser processados
                    corretamente.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Converter para os formatos aceitos:{" "}
                    </a>
                    Se o arquivo estiver em outro formato, utilize ferramentas
                    como Excel, Google Sheets, ou conversores online para
                    transformá-lo em .xlsx ou .csv.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Evite arquivos com extensões incompatíveis:{" "}
                    </a>
                    Formatos como .pdf, .docx, ou .txt não são adequados.
                    Garanta que o arquivo esteja estruturado como uma planilha,
                    com colunas e linhas bem definidas.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Verifique os dados no arquivo convertido:{" "}
                    </a>
                    Após a conversão, revise o conteúdo para confirmar que os
                    dados foram preservados corretamente e que o layout está
                    adequado.
                  </li>
                </ul>

                <figure>
                  <img src="img/tipo-de-arquivo.png" alt="excel" />
                </figure>

                <figcaption>Tipo do arquivo</figcaption>

                <p>
                  <h5>Codificação UTF-8 ou "Windows 1252: Western European</h5>
                </p>

                <p>
                  Para garantir que o arquivo seja processado corretamente, é
                  essencial que a codificação do texto esteja em{" "}
                  <a style={{ fontWeight: "bold" }}>
                    UTF-8 ou Windows 1252: Western European
                  </a>
                  . Confira abaixo como proceder:
                </p>

                <ul>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Verifique a codificação do arquivo:{" "}
                    </a>
                    Utilize um editor de texto, como Notepad++ ou VS Code, para
                    confirmar a codificação atual. Essa informação geralmente
                    está disponível nas configurações do editor ou ao salvar o
                    arquivo.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Ajuste a codificação, se necessário:{" "}
                    </a>
                    Se a codificação não for UTF-8 ou Windows 1252, converta o
                    arquivo. No Excel ou Google Sheets, ao salvar como .csv,
                    selecione a opção de codificação UTF-8. Em editores de
                    texto, escolha a codificação correta antes de salvar o
                    arquivo.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Cuidado com caracteres especiais:{" "}
                    </a>
                    Certifique-se de que a conversão mantém caracteres especiais
                    (acentos, cedilhas, etc.) intactos. Problemas com esses
                    caracteres podem indicar incompatibilidade de codificação.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Teste o arquivo após a conversão:{" "}
                    </a>
                    Depois de ajustar a codificação, abra o arquivo em
                    diferentes softwares para confirmar que ele está legível e
                    que os dados estão intactos.
                  </li>
                </ul>

                <figure>
                  <img src="img/tipo-de-arquivo-02.png" alt="excel" />
                </figure>

                <figcaption>Codificação do arquivo</figcaption>

                <p>
                  <h5>Cabeçalho sem identificador para CPF, CNPJ ou e-mail</h5>
                </p>

                <p>
                  Para que o arquivo seja processado corretamente, é essencial
                  que as colunas correspondentes a CPF, CNPJ ou e-mail possuam
                  cabeçalhos identificadores claros. Veja como garantir isso:
                </p>

                <ul>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Defina cabeçalhos claros e específicos:{" "}
                    </a>
                    Certifique-se de que os nomes das colunas contenham palavras
                    que identifiquem claramente os dados.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Evite cabeçalhos genéricos ou ambíguos:{" "}
                    </a>
                    Não utilize termos como Número, Identificação ou Dados, pois
                    podem dificultar o reconhecimento automático das
                    informações.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Padronize a nomenclatura no arquivo:{" "}
                    </a>
                    Use a mesma nomenclatura em todas as colunas para evitar
                    erros ou confusões.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Revise o arquivo antes de enviá-lo:{" "}
                    </a>
                    Confira se as colunas obrigatórias estão presentes, com os
                    cabeçalhos devidamente preenchidos e os dados organizados.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Corrija nomes de cabeçalhos, se necessário:{" "}
                    </a>
                    Caso precise ajustar os cabeçalhos, abra o arquivo em uma
                    ferramenta como Excel ou Google Sheets e edite os títulos
                    das colunas.
                  </li>
                </ul>

                <figure>
                  <img src="img/cabecalho-do-arquivo.png" alt="excel" />
                </figure>

                <figcaption>Cabeçalho do arquivo</figcaption>

                <p>
                  <h5>Células encapsuladas em aspas duplas</h5>
                </p>

                <p>
                  Para que o arquivo seja processado corretamente, não devem
                  existir células encapsuladas em aspas duplas. Siga estas
                  orientações para evitar problemas:
                </p>

                <ul>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Verifique a presença de aspas duplas no arquivo:{" "}
                    </a>
                    Abra o arquivo em um editor de texto (como Notepad++) ou em
                    uma planilha (Excel ou Google Sheets) e confira se há
                    células com valores como "dados" ou aspas duplas no
                    conteúdo.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Corrija células com aspas duplas:{" "}
                    </a>
                    No Excel ou Google Sheets, substitua aspas duplas nas
                    células usando a ferramenta de localizar e substituir (Ctrl
                    + H). Em arquivos .csv, abra o arquivo em um editor de texto
                    e remova as aspas duplas utilizando comandos de busca e
                    substituição.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Evite salvar com aspas duplas automaticamente:{" "}
                    </a>
                    Ao exportar arquivos .csv, algumas ferramentas encapsulam
                    células em aspas duplas automaticamente. Certifique-se de
                    configurar a exportação corretamente ou revise o arquivo
                    após salvar.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Teste o arquivo após a correção:{" "}
                    </a>
                    Após remover as aspas duplas, abra o arquivo novamente em
                    diferentes programas para confirmar que os dados estão
                    corretos e que a formatação foi preservada.
                  </li>
                </ul>

                <figure>
                  <img src="img/celula-com-aspas-duplas.png" alt="excel" />
                </figure>

                <figcaption>Células com aspas duplas</figcaption>

                <p>
                  <h5>Dados com notação científica</h5>
                </p>

                <p>
                  Para evitar problemas no processamento, certifique-se de que
                  os dados no arquivo não estejam em notação científica (por
                  exemplo, 1.23E+10). Siga estas orientações para identificar e
                  corrigir esse problema:
                </p>

                <ul>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Verifique a presença de notação científica:{" "}
                    </a>
                    Abra o arquivo em um editor de planilhas (como Excel ou
                    Google Sheets) e identifique células onde os números
                    aparecem em formato de notação científica, geralmente
                    aplicada automaticamente a números muito grandes ou
                    pequenos.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Desative a notação científica:{" "}
                    </a>
                    Selecione as colunas afetadas, acesse o menu de formatação e
                    altere o formato da célula para o tipo "Geral", sem
                    especificação de fórmula ou formatação.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Evite salvar novamente em notação científica:{" "}
                    </a>
                    Ao exportar dados para .csv, revise as configurações do
                    software para que os números sejam mantidos no formato
                    padrão e não convertidos automaticamente para notação
                    científica.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Teste o arquivo corrigido:{" "}
                    </a>
                    Após ajustar os dados, abra o arquivo em diferentes
                    programas para confirmar que os valores aparecem no formato
                    desejado.
                  </li>
                </ul>

                <figure>
                  <img src="img/excel-notacao-cientifica.png" alt="excel" />
                </figure>

                <figcaption>Exemplo de notação científica</figcaption>

                <p>
                  <h5>Células em branco</h5>
                </p>

                <p>
                  Células em branco nos dados identificadores como CPF, CNPJ ou
                  e-mail podem causar problemas no processamento do arquivo.
                  Para evitar isso, siga as orientações abaixo:
                </p>

                <ul>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Identifique as células em branco:{" "}
                    </a>
                    Abra o arquivo em um editor de planilhas (como Excel ou
                    Google Sheets) e percorra as colunas e linhas para localizar
                    células vazias entre os dados.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Determine o tratamento adequado:{" "}
                    </a>
                    Preencha as células que deveriam conter dados com as
                    informações corretas ou exclua a linha/coluna caso seja
                    necessário.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Evite salvar arquivos com células em branco:{" "}
                    </a>
                    Antes de salvar o arquivo, revise e certifique-se de que
                    todas as células obrigatórias estão preenchidas. Considere
                    excluir linhas ou colunas desnecessárias para garantir um
                    arquivo limpo.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Teste o arquivo corrigido:{" "}
                    </a>
                    Após ajustar os dados, revise o arquivo para confirmar que
                    as alterações foram aplicadas corretamente e que o formato
                    está adequado.
                  </li>
                </ul>

                <figure>
                  <img src="img/celula-vazia.png" alt="excel" />
                </figure>

                <figcaption>Células em branco</figcaption>

                <p>
                  <h5>Sobre o tipo de dado CPF e CNPJ</h5>
                </p>

                <p>
                  Também não é necessário que os dados estejam com máscara.
                  Portanto, retire qualquer ponto, vírgula ou traço nos valores
                  de CPF e CNPJ. Se você precisa copiar os valores para outro
                  arquivo excel, sugerimos colar no formato 'valores'. Com esta
                  opção os valores da células são copiadas excluindo fórmulas e
                  formatação.
                </p>

                <figure>
                  <img src="img/excel1.png" alt="excel" />
                </figure>

                <figcaption>Excel - Colar valores</figcaption>

                <p>
                  <h5>Salvando um arquivo .csv com campo de CNPJ</h5>
                </p>

                <p>
                  Ao manipular um arquivo .csv que contenha campo de CNPJ, é
                  comum que esse tipo de dado seja modificado ao salvar o
                  arquivo. Essa modificação pode prejudicar o enriquecimento dos
                  dados em nossa plataforma. Para evitar esse tipo de problema,
                  siga as seguintes orientações:
                </p>

                <ul>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Personalize o formato dos dados:{" "}
                    </a>
                    Selecione as células ou a coluna com CNPJ, clique com o
                    botão direito do mouse e escolha a opção "Formatar
                    células...", em seguida selecione a categoria
                    "Personalizado" e em "tipo" apague o modelo atual e digite
                    14 zeros em sequência (que é o total de dígitos de um CNPJ),
                    clique em "Ok" e salve o arquivo.
                  </li>
                </ul>

                <figure>
                  <img src="img/formato-dos-dados.png" alt="excel" />
                </figure>
                <figcaption>Excel - Formatar célula</figcaption>

                <ul>
                  <li>
                    <a style={{ fontWeight: "bold" }}>Teste o arquivo: </a>
                    Após ajustar os dados, revise o arquivo para confirmar que
                    as alterações foram aplicadas corretamente e que o formato
                    está adequado.
                  </li>

                  <li>
                    <a style={{ fontWeight: "bold" }}>Ponto de atenção: </a>
                    Após realizar estes ajustes , não salve o arquivo novamente,
                    pois isso fará com que os dados sejam perdidos e será
                    necessário refazer todo o processo através do arquivo
                    original.
                  </li>
                </ul>

                <p>
                  Seguindo essas orientações, você evitará inconsistências,
                  garantindo um processamento eficiente e confiável do arquivo.
                </p>

                <br></br>
              </div>

              {/* Seção de votos */}

              <div>
                <PesquisaArtigo />
              </div>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuInicioRapido />
            </div>
          </div>
        </div>

        <br></br>

        {showScrollButton && (
          <a onClick={scrollToTop} className="btn-topo">
            <a style={{ fontSize: "25px" }}>↑</a> Voltar ao Topo
          </a>
        )}
      </section>
      <Footer />
    </>
  );
}
